import { Layer, PatternElement } from '../types';

// PatternPreviewとsvgExportで共通のパターン要素生成ロジック
export function generatePatternElements(
  layer: Layer,
  width: number,
  height: number
): PatternElement[] {
  // レイヤーが非表示またはパターンがない場合は空配列を返す
  if (!layer.svgPattern || !layer.visible) return [];

  const { size: patternSize, gapX, gapY, angle } = layer.parameters;
  const angleRad = (layer.parameters.angleView * Math.PI) / 180;
  // TODO: 関数(引数, angleRad, width, height)でまとめる
  const rotatedWidth =
    Math.abs(Math.cos(angleRad) * width) +
    Math.abs(Math.sin(angleRad) * height);
  const rotatedHeight =
    Math.abs(Math.sin(angleRad) * width) +
    Math.abs(Math.cos(angleRad) * height);
  const extraMargin = Math.max(rotatedWidth, rotatedHeight) * 0.5;

  const startX = -extraMargin;
  const startY = -extraMargin;
  const endX = width + extraMargin;
  const endY = height + extraMargin;

  const patterns: PatternElement[] = [];
  let patternIndex = 0;

  for (let y = startY; y < endY; y += patternSize - gapY) {
    for (let x = startX; x < endX; x += patternSize - gapX) {
      const isEvenColumn = Math.floor(x / (patternSize - gapX)) % 2 === 0;

      let transform: string;
      if (isEvenColumn) {
        // 偶数列のパターン配置
        transform = `translate(${x}, ${y})`;
      } else {
        // 奇数列のパターン配置
        const centerX = x + patternSize / 2;
        const centerY = y + patternSize / 2;
        transform = `translate(${centerX}, ${centerY}) rotate(${angle}) translate(${
          -patternSize / 2
        }, ${-patternSize / 2})`;
      }

      patterns.push({
        key: `pattern-${layer.id}-${patternIndex}`,
        transform,
        size: patternSize,
      });
      patternIndex++;
    }
  }

  return patterns;
}
